import Demographics from '../PatientDetails/Demographics/Demographics'
import Insurrance from '../PatientDetails/Insurrance/Insurrance'
import Guarantor from '../PatientDetails/Guarantor/Guarantor'
import Encounter from '../PatientDetails/Encounter/Encounter'
import PatientsSummary from '../PatientDetails/Summary/PatientSummary'
import Documents from '../PatientDetails/Documents/Documents'
import paymenticon from "../../../assets/img/PAYMENTS.svg"
import PatientCalendar from '../PatientDetails/PatientCalendar/PatientCalendar'
import { useSelector } from 'react-redux'
import { FindFirstChild } from '../../../utils/FindMenuOption'
import PatientMessages from '../PatientDetails/PatientMessages/PatientMessages'
import TimeLine from '../PatientDetails/TimeLine/TimeLine'
import PatientPaymentsPat from '../PatientDetails/PatientPayment/PatientPaymentsPat'
const isLive = process.env.REACT_APP_ISLIVE
const PatientMenu = () => {
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let PatientPortalAccessRedux = useSelector(state => state.SettingsReducer?.PatientPortalAccess);

    const isHomeCareCheck = DropDowns.IsHomeCare
    let isHomecareOrADC = useSelector(state => ["Adult Day Care", "Homecare Agency"].includes(state.GeneralDropDownsReducer.PracticeType))
    return [
        {
            name: 'All Patients',
            key: 21,
            icon: "",
            right: true,
            subCategoryItems: [
                {
                    name: 'Summary',
                    key: 211,
                    icon: "icon-claims",
                    component: <PatientsSummary />,
                    right: true
                },
                PatientPortalAccessRedux !== 'false' || PatientPortalAccessRedux !== false
                    ? {
                        name: 'Demographics',
                        key: 212,
                        icon: "icon-Demographics-icon",
                        component: <Demographics />,
                        right: FindFirstChild('Patient', 'Demographics')?.ISView,
                    }
                    : null,

                {
                    name: 'Insurance',
                    key: 213,
                    icon: "icon-umbrella-solid",
                    component: <Insurrance />,
                    right: true, // need to review
                },
                ...(isHomeCareCheck !== 'true' ? [
                    {
                        name: 'TimeLine',
                        key: 220,
                        icon: "icon-Payments1",
                        component: <TimeLine />,
                        right: FindFirstChild('Patient', 'Timeline')?.ISView,
                    }
                ] : []),
                {
                    name: 'Documents',
                    key: 214,
                    icon: "icon-page",
                    component: <Documents />,
                    right: FindFirstChild('Patient', 'Document')?.ISView,
                },
                {
                    name: 'Guarantor',
                    key: 215,
                    icon: "icon-Gurantor-icon",
                    component: <Guarantor />,
                    right: FindFirstChild('Patient', 'Gurantor')?.ISView,
                },
                ...(isHomeCareCheck !== 'true' ? [
                    {
                        name: 'Payments',
                        key: 216,
                        icon: "icon-Payments1",
                        component: <PatientPaymentsPat />,
                        right: FindFirstChild('Patient', 'Payments')?.ISView,
                        // img:true,
                        // imgSrc:paymenticon,
                    }
                ] : [
                    {
                        name: 'Calendar',
                        key: 217,
                        icon: "icon-SCHEDULER",
                        component: <PatientCalendar />,
                        right: FindFirstChild('Patient', 'Calendar')?.ISView,
                        // img:true,
                        // imgSrc:paymenticon,
                    },
                ]),
                ...(!isHomecareOrADC ? [
                    {
                        name: 'Encounter',
                        key: 218,
                        icon: "icon-document-add-svgrepo-com ar-dark-icon fs-18",
                        component: <Encounter />,
                        // right: FindFirstChild('Patient', 'Encounter')?.ISView,
                        right: true
                        // img:true,
                        // imgSrc:paymenticon,
                    },
                ] : []),

                ...(!isHomecareOrADC ? [
                    {
                        name: 'Messages',
                        key: 219,
                        icon: "icon-messages",
                        component: <PatientMessages />,
                        right: FindFirstChild('Patient', 'Messages')?.ISView,
                    },
                ] : []),

            ]
        },
    ]
}


export default PatientMenu